// noinspection GraphQLUnresolvedReference

export const listChairsCatalog = /* GraphQL */ `
    query ListChairsCatalog($categories: [QueryArgument], $search: String, $limit: Int, $offset: Int) {
        chairEntries(categories: $categories, search: $search, limit: $limit, offset: $offset) {
            ... on variant_Entry {
                id
                title
                itemNumber
                variantName
                parent {
                    ... on chair_Entry {
                        chairName
                    }
                }
                previewImage {
                    ... on images_Asset {
                        url @transform(width: 200, height: 200, mode: "letterbox")
                        title
                    }
                }
            }
        }
    }
`;

export const getChairVariantUrl = /*GraphQL */ `query GetChairVariantUrl($id: [QueryArgument]) {
    chairEntries(id: $id) {
        ... on variant_Entry {
            variantName
            variantModel {
                url
            }
        }
    }
}
`;

export const getChairVariantInfo = /*GraphQL */ `query GetChairVariantInfo($id: [QueryArgument]) {
    chairEntries(id: $id) {
        ... on variant_Entry {
            variantName
            parent {
                ... on chair_Entry {
                    chairName
                    notes {
                        ... on notesBlock_Entry {
                            note
                        }
                    }
                }
            }
            itemNumber
            measurements
            fabricLFM
            leatherM2
            categories
            variantCost {
                ... on variantCostBlock_Entry {
                    coverCost
                }
            }
            variantDescription
        }
    }
}
`;

export const getChairConfiguratorInfo = /*GraphQL */ `query GetChairConfiguratorInfo($id: [QueryArgument]) {
    chairEntries(id: $id) {
        ... on variant_Entry {
            variantName
            parent {
                ... on chair_Entry {
                    chairName
                    id
                    accessory {
                        ... on accessoryBlock_Entry {
                            accessoryName {
                                ... on glider_Entry {
                                    title
                                    articleID
                                }
                            }
                            accessoryCost
                        }
                    }
                }
            }
            variantDescription
            frames {
                ... on framesBlock_Entry {
                    frame {
                        ... on frame_Entry {
                            id
                            frameName
                            textures {
                                ... on texturesBlock_Entry {
                                    cost
                                    shininess
                                    textureName
                                    texture {
                                        id
                                    }
                                }
                            }
                        }
                    }
                    frameCost
                }
            }
            secondaryFrame {
                ... on secondaryFrameBlock_Entry {
                    shininess
                    secondaryFrameTexture {
                        id
                    }
                }
            }
        }
    }
}
`;

export const listChairVariants = /*GraphQL */ `
    query ListChairVariants($id: [QueryArgument]) {
        chairEntries(id: $id) {
            ... on chair_Entry {
                id
                children {
                    ... on variant_Entry {
                        id
                        previewImage {
                            url @transform(width: 50, height: 50, mode: "letterbox")
                            title
                        }
                        variantName
                        variantDescription
                    }
                }
                chairName
            }
        }
    }
`;

export const listVariantCovers = /*GraphQL */ `
    query ListVariantCovers($id: [QueryArgument]) {
        chairEntries(id: $id) {
            ... on variant_Entry {
                variantCost {
                    ... on variantCostBlock_Entry {
                        cover {
                            id
                            ... on cover_Entry {
                                id
                                category
                                title
                                withoutCover
                            }
                        }
                        coverCost
                    }
                }
            }
        }
    }
`;

export const listVariantCategoryFinishing = /*GraphQL */ `
    query ListVariantFinishing($id: [QueryArgument], $category: [QueryArgument], $search: String) {
        chairEntries(id: $id) {
            ... on variant_Entry {
                variantCost {
                    ... on variantCostBlock_Entry {
                        cover(category: $category) {
                            id
                            title
                            ... on cover_Entry {
                                id
                                category
                                collection {
                                    ... on colorCatalog_Entry {
                                        id
                                        colors(search: $search) {
                                            id
                                        }
                                        finishing {
                                            ... on finishing_Entry {
                                                id
                                                title
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

`;
